var whVideoLanding = whVideoLanding || {};

if (!Object.create) {
    Object.create = (function () {
        function F() {}

        return function (o) {
            if (arguments.length != 1) {
                throw new Error('Object.create implementation only accepts one parameter.');
            }
            F.prototype = o;
            return new F();
        };
    })();
}

jQuery(function ( $ ) {

    $.fn.whLanding = function( options ) {
        return this.each(function() {
            var whLanding = Object.create(whVideoLanding.whLanding);
            whLanding.init(this, options);
        });
    };

    $.fn.whLanding.options = {

     };

    whVideoLanding.whLanding = {

        init (elem, options) {
            var self = this;
            self.$container = $(elem);
            self.options = $.extend({}, $.fn.showHide.options, options);

            self.$playButton = self.$container.find(".health-landing__trigger");
            self.$modalId = self.$playButton.data("remodal-target")
            self.$modal = $("body").find("[data-remodal-id=" + self.$modalId + "]");
            self.$videoDiv = self.$modal.find(".health-landing__video");
            self.$videoID = self.$modal.data("modalvideo");
            self.bindElements();
        },

        bindElements () {
            var self = this;

            self.$playButton.length > 0 && self.setModal();
        },

        setModal() {
            var self = this;
            var options = {
                    id: self.$videoID,
                    width: 1400,
                    loop: false,
                    byline : false,
                    title: false,
                    portrait: false

                };
                    
            self.$player = new Vimeo.Player(self.$videoDiv[0], options);

            self.$modal.on('closing',  function (e) {
                self.$player.pause();
            });
        }

    };
});
